import $ from "jquery";
import smoothscroll from "smoothscroll-polyfill";

/*
	Mobile Navigation
*/
$(document).ready(function() {
  $("#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4").click(function() {
    $(this).toggleClass("open");
  });
});

$(document).ready(function() {
  $("#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4").click(function() {
    $(".mobile-nav--overlay").toggleClass("open");
    $("body").toggleClass("overflow-hidden");
  });
});

$(".mobile-navigation--link.depth-1.has-sub").click(function(e) {
  e.preventDefault();
  //$('.mobile-navigation--menu-item.depth-1.has-sub').removeClass('open');
  $(".sub-indicator").text("+");
  $(this)
    .parent("li")
    .toggleClass("open");

  const item = $(this).parent("li");
  if (item.hasClass("open")) {
    item.children(".sub-indicator").text("-");
  } else {
    item.children(".sub-indicator").text("+");
  }
});

/*
	Desktop Navigation
*/
$(".nav-desktop--level-1-item.has-sub")
  .children(".nav-desktop--level-1-link")
  .click(function(e) {
    e.preventDefault();
    const des = $(this);
    if (
      $(this)
        .siblings(".nav-desktop--level-2")
        .hasClass("open")
    ) {
      des.siblings(".nav-desktop--level-2").removeClass("open");
    } else {
      $(".nav-desktop--level-2").removeClass("open");
      $(this)
        .siblings(".nav-desktop--level-2")
        .toggleClass("open");
    }
  });

/*
	Hover Interaction
*/
$(".nav-desktop--level-1-item").mouseenter(function() {
  $(this)
    .children(".bar-wrap")
    .children(".bar")
    .addClass("hover");
});

$(".nav-desktop--level-1-item").mouseleave(function() {
  $(this)
    .children(".bar-wrap")
    .children(".bar")
    .removeClass("hover");
});

/*
	Indicationbar Activestate
*/
$(".nav-desktop--level-1-link").each(function() {
  $(".nav-desktop--level-1-link.active")
    .siblings(".bar-wrap")
    .children(".bar")
    .addClass("active");
});

$(".nav-desktop--level-2-link.active")
  .parents(".nav-desktop--level-1-item.has-sub")
  .children(".bar-wrap")
  .children(".bar")
  .addClass("active");

if (document.location.pathname === "/kontakt") {
  const contactmail = document.querySelector("#contact-mail");

  contactmail.addEventListener("click", function(e) {
    e.preventDefault();

    document.location.href =
      "mailto:info@lifebeton.at?subject=Mailanfrage%20an%20Lifebeton";
  });
}

// STICKY NAV
const body = document.querySelector("body");
const nav = document.querySelector("#maindrop");
const topOfNav = nav.offsetTop;
const height = nav.offsetHeight;
nav.style.display = "none";

if (window.matchMedia("(min-width: 800px)").matches) {
  function fixNav() {
    if (window.scrollY >= 170) {
      if (!body.classList.contains("nav-fixed")) {
        nav.style.display = "flex";
        nav.style.transform = `translateY(-${height}px)`;
      } else {
        nav.style.transform = "translateY(0)";
      }
    }

    if (window.scrollY >= 300) {
      body.classList.add("nav-fixed");
    } else {
      if (body.classList.contains("nav-fixed")) {
        nav.style.transform = `translateY(-${height}px)`;
        setTimeout(function() {
          body.classList.remove("nav-fixed");
          nav.style.display = "none";
          nav.style.transform = "translateY(0)";
        }, 300);
      }
    }
  }
  window.addEventListener("scroll", fixNav);
}

// TOTOP ARROW
smoothscroll.polyfill();
const toTop = document.querySelector("#to-top");

document.querySelector("#to-top").addEventListener("click", function(e) {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
});

function showToTop() {
  if (window.scrollY >= 300) {
    toTop.classList.add("show");
  } else {
    toTop.classList.remove("show");
  }
}

window.addEventListener("scroll", showToTop);



// WEBPACK FOOTER //
// ./src/js/navigation.js